<p class="error margin-0 text-danger small">
	<ng-content></ng-content>
</p>
